/* eslint-disable quotes */
import { Component } from '@angular/core';
import { IResponse } from 'src/app/@amiga-pyme/services/core.service';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { SaleDetailService } from '../sale-details.service';
import { SaleEmitService } from '../sale-emit.service';
import { SalePendingService } from '../sale-pending.service';
import { getTagColor } from '../../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-sale-pending-document',
  templateUrl: './sale-pending-document.component.html'
})
export class SalePendingDocumentComponent extends TableActionsTemplate {
  confirmSettings = {};
  idDocument: number;
  detailsResponse: IResponse;
  constructor(
    private serviceBase: SalePendingService,
    private saleEmitService: SaleEmitService,
    private saleDetailService: SaleDetailService
  ) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Boleta y Factura Pendientes',
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Pt.V.', field: 'pointSaleCode' },
        { header: 'Voucher', field: 'typeVoucher', tag: 'tagStatus' },
        { header: 'Serie', field: 'serie' },
        { header: 'Correlative', field: 'correlative' },
        { header: 'Moneda', field: 'typeMoney' },
        { header: 'SubTotal', field: 'valueSale', pipe: 'Currency' },
        { header: 'IGV', field: 'mtoIGV', pipe: 'Currency' },
        { header: 'Total', field: 'mtoTaxSale', pipe: 'Currency' }
      ],
      filterColumns: true
    };
    this.table.actions = [
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      },
      {
        name: 'emit-bill',
        icon: 'pi pi-arrow-up',
        class: 'p-button-rounded p-button-warning',
        pTooltip: 'Emitir'
      }
    ];
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase.getData$().subscribe((data) => {
      data = data.map((item) => {
        item.tagStatusColor = getTagColor(item.typeVoucher);
        return item;
      });
      this.table.data = data;
    });
  }

  async onReciveAction(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      if (action === 'emit-bill') {
        this.confirmSettings = {
          message: 'EMITIR',
          action: 'emit-bill',
          data
        };
      } else if (action === 'see-details') {
        this.detailsResponse = {
          message: 'Esperando detalles del documento...',
          status: null
        };

        this.idDocument = data.id;
      }
    }
  }

  async actionConfirmed(event) {
    const { action, data } = event;
    if (action === 'emit-bill') {
      const { id } = data;
      this.message = { message: 'Emitiendo Compronte' };
      this.message = await this.saleEmitService.update(id, null);
    }
  }
  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
